import { z } from "zod";
import { safeHttpUrlSchema } from "../safe-url";

export const downloadCategoryEnum = z.enum([
  "lecture_notes",
  "slides",
  "syllabus",
  "dataset",
  "code_sample",
  "handout",
  "other",
]);

export const downloadItemSchema = z.object({
  id: z.string().uuid().default(() => crypto.randomUUID()),
  title: z.string().max(255).default(""),
  category: downloadCategoryEnum.default("lecture_notes"),
  description: z.string().max(1000).optional(),
  fileUrl: z.union([safeHttpUrlSchema, z.literal("")]).default(""),
  fileName: z.string().max(255).optional(), // e.g. "Lecture_04_Optics.pdf"
  fileSize: z.string().max(50).optional(), // e.g. "3.5 MB"
  fileFormat: z.string().max(20).optional(), // e.g. "PDF", "PPTX", "ZIP"
  publishDate: z.string().max(50).optional(),
});


import { getSectionDisplayOptionsSchema } from "../display-options";

export const downloadsDisplayOptionsSchema = getSectionDisplayOptionsSchema("downloads");
export type DownloadsDisplayOptions = z.infer<typeof downloadsDisplayOptionsSchema>;

export const downloadsContentSchema = z.object({
  heading: z.string().min(1).max(100).default("Downloads & Resources"),
  items: z.array(downloadItemSchema).max(50).default([]),
  displayOptions: downloadsDisplayOptionsSchema.optional(),
});

export type DownloadCategory = z.infer<typeof downloadCategoryEnum>;
export type DownloadItem = z.infer<typeof downloadItemSchema>;
export type DownloadsContent = z.infer<typeof downloadsContentSchema>;
